type RGBColor = [number, number, number];

const hexToRGB = (hex: string): RGBColor | null => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

    return result
        ? [
            parseInt(result[1], 16),
            parseInt(result[2], 16),
            parseInt(result[3], 16)
        ]
        : null;
};

export const interpolateRGBColors = (
    startRGB: RGBColor,
    finishRGB: RGBColor,
    steps: number
) => {
    const stepFactor = 1 / (steps - 1);
    const colorInterpolationArray: RGBColor[] = [];
        
    for (let stepIndex = 0; stepIndex < steps; stepIndex++) {
        const resultRGB: RGBColor = [startRGB[0], startRGB[1], startRGB[2]];
            
        for (let i = 0; i < resultRGB.length; i++) {
            resultRGB[i] = Math.round(
                resultRGB[i] + (stepFactor * stepIndex) * (finishRGB[i] - startRGB[i])
            );
        }

        colorInterpolationArray.push(resultRGB);
    }

    return colorInterpolationArray;
};

const rgbToString = (rgb: RGBColor): string => {
    return `rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]})`;
};

export const interpolateColors = (
    startColor: string,
    finishColor: string,
    steps: number
) => {
    const startRGB = hexToRGB(startColor);
    const finishRGB = hexToRGB(finishColor);

    if (!startRGB || !finishRGB) {
        return null;
    }

    const colorInterpolationArray = interpolateRGBColors(startRGB, finishRGB, steps);
    return colorInterpolationArray.map(rgbToString);
};
